// longeva-scroll-velocity.js
// The signature unforgettable beat. A hairline brass rule sits under
// the header (rendered by longeva-head-additions.liquid as <div
// class="longeva-header-rule">). This script measures scroll-velocity
// per frame and sets --longeva-scroll-intensity on :root from 0..1.
// CSS in longeva-motion.css interpolates the rule's opacity + height
// from that variable.
//
// Performance: passive listener, rAF-throttled, ~600 bytes gzipped.
// No competitor in UK clinical aesthetics does this — it reads as
// "the interface is aware" without any AI gimmick.

(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var lastY = window.scrollY;
  var raf = null;
  var idleTimer = null;
  var root = document.documentElement;

  function decay() {
    // Bleed intensity back to 0 over time when scroll stops
    var current = parseFloat(getComputedStyle(root).getPropertyValue('--longeva-scroll-intensity')) || 0;
    if (current <= 0.01) {
      root.style.setProperty('--longeva-scroll-intensity', '0');
      return;
    }
    root.style.setProperty('--longeva-scroll-intensity', String(current * 0.85));
    idleTimer = setTimeout(decay, 80);
  }

  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      var delta = Math.abs(window.scrollY - lastY);
      var intensity = Math.min(delta / 24, 1); // 0..1
      root.style.setProperty('--longeva-scroll-intensity', String(intensity));
      lastY = window.scrollY;
      raf = null;
      // Reset the decay timer
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(decay, 160);
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
